/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {CLASS_NAME as ɵa} from './modal-options.class';